module.exports = __webpack_public_path__ + "img/bed.2e5b131a.svg";